import { FC } from 'react';
import {
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

interface CertificationMemberHeaderProps {
  propertyName: string;
  categoryName?: string;
  memberName?: string;
  memberTypeName?: string;
  showPropertyIcon?: boolean;
}

const CertificationMemberHeader: FC<CertificationMemberHeaderProps> = ({
  propertyName,
  categoryName,
  memberName,
  memberTypeName,
  showPropertyIcon = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={isMobile ? 'center' : 'flex-start'}
      gap={1.5}
    >
      <Stack direction="row" alignItems="center" gap={0.75}>
        {showPropertyIcon && <HomeIcon color="action" fontSize="small" />}
        <Stack
          gap={0}
          sx={{
            ...(isMobile ? { alignItems: 'center' } : undefined),
            overflow: 'hidden',
          }}
        >
          <Typography variant="h6">{propertyName}</Typography>
          {categoryName && (
            <Typography variant="caption" color="text.secondary">
              {categoryName}
            </Typography>
          )}
        </Stack>
      </Stack>
      {memberName && (
        <>
          <Divider
            orientation="vertical"
            sx={{ borderRightWidth: 3 }}
            flexItem
          />
          <Stack
            gap={0}
            sx={{
              ...(isMobile ? { alignItems: 'center' } : undefined),
              overflow: 'hidden',
            }}
          >
            <Typography variant="h6">{memberName}</Typography>
            {memberTypeName && (
              <Typography variant="caption" color="text.secondary">
                {memberTypeName}
              </Typography>
            )}
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default CertificationMemberHeader;
